// extracted by mini-css-extract-plugin
export default {"grey100":"#f5f5f5","grey500":"#9e9e9e","page":"Permanent_page__Z1+fJ","content":"Permanent_content__FBcV3","drawer":"Permanent_drawer__GiW4l"};